import { Container } from '@icecreamsocial/components';
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { Footer } from '../../presentational';
import { SubscriptionOptions } from './views/SubscriptionOptions';
export const Main = () => {
	return (
		<>
			<Router>
				<Switch>
					<Route path="/" exact>
						<SubscriptionOptions />
					</Route>
				</Switch>
			</Router>
			<Footer />
		</>
	);
};
